import { merge } from "lodash";
import {
  FETCH_COLLATED_REQUEST,
  FETCH_COLLATED_SUCCESS,
  FETCH_COLLATED_FAILURE
} from "../types";

const fetchInvoice = (state, { type, payload }) => {
  switch (type) {
    case FETCH_COLLATED_REQUEST:
      return {
        ...state,
        loadingCollated: true
      };
    case FETCH_COLLATED_SUCCESS:
      return {
        ...state,
        collatedDocs: merge({}, state.collatedDocs, payload),
        loadingCollated: false
      };
    case FETCH_COLLATED_FAILURE:
      return {
        ...state,
        error: true,
        loadingCollated: false
      };
    default:
      return {
        ...state
      };
  }
};

export default fetchInvoice;
